import { apiClient } from './apiClient';
import { logAudit, AUDIT_ACTIONS, AUDIT_ENTITIES } from './auditLog';

interface AutoBugReportParams {
  title: string;
  description: string;
  errorDetails: Record<string, unknown>;
  pageContext: string;
  priority?: 'low' | 'medium' | 'high' | 'critical';
}

export async function submitAutoBugReport(params: AutoBugReportParams): Promise<void> {
  try {
    const created = await apiClient.post<{ id: string }>('/api/feedback', {
      type: 'bug',
      title: params.title,
      description: params.description,
      priority: params.priority || 'high',
      page_context: params.pageContext,
      user_agent: navigator.userAgent,
      error_details: params.errorDetails,
    });

    logAudit({
      action: AUDIT_ACTIONS.CREATE,
      entityType: AUDIT_ENTITIES.FEEDBACK,
      entityId: created.id,
      entityLabel: `[Auto] ${params.title}`,
      details: { type: 'bug', priority: params.priority || 'high', auto: true },
      pageContext: params.pageContext,
    });
  } catch (err) {
    console.error('Auto bug report failed:', err);
  }
}
